import { Donut } from '@/features/ah/charts';
import type { PrijsfavorietenPayload } from '../report';
import { fmtPct } from '../utils';

/*
 * 03 — Gameplay: how many games players play (donut) and how many campaign
 * weeks they came back for (bars). Both are share-of-players, so the donut's
 * segments are percentages and its centre reads 100%.
 */

// AH blues, darkest → lightest, with the gold accent last (matches the AH
// dashboard's chart palette so both reports look related).
const SEGMENT_COLORS = ['#0E4A82', '#1B6FB8', '#4B93CC', '#8FBEE0', '#B89030'];

export function GameplaySection({ gameplay }: { gameplay: PrijsfavorietenPayload['gameplay'] }) {
  const dist = gameplay.distribution;
  const repeat = gameplay.repeat;
  const maxRepeat = Math.max(...repeat.rows.map((r) => r.pct), 1);

  return (
    <section id="gameplay" className="section">
      <div className="section-head">
        <div>
          <div className="eyebrow">03 — Gameplay</div>
          <h2>Speelgedrag per bezoeker</h2>
        </div>
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-head">
            <h3>Hoeveel games spelen bezoekers?</h3>
            <span className="meta">Verdeling spelers</span>
          </div>
          <div className="dist-block">
            <Donut segments={dist.map((d, i) => ({ value: d.pct, color: SEGMENT_COLORS[i % SEGMENT_COLORS.length] }))} />
            <div className="dist-list">
              {dist.map((d, i) => (
                <div className="dist-row" key={d.label}>
                  <span className="swatch" style={{ background: SEGMENT_COLORS[i % SEGMENT_COLORS.length] }} />
                  <span className="label">{d.label}</span>
                  <span className="v">{fmtPct(d.pct)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-head">
            <h3>Spelers per aantal weken</h3>
            <span className="meta">Herhaalgedrag</span>
          </div>
          <div className="ah-stat-big">{fmtPct(repeat.allWeeksPct)}</div>
          <div className="ah-stat-desc">speelde in alle weken van de campagne</div>
          <div className="hbar-list pf-card-gap">
            {repeat.rows.map((r) => (
              <div className="hbar-row" key={r.label}>
                <span className="label">{r.label}</span>
                <div className="bar">
                  <div className="bar-fill" style={{ width: `${(r.pct / maxRepeat) * 100}%` }} />
                </div>
                <span className="v">{fmtPct(r.pct)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
